module.exports = __webpack_public_path__ + "img/1.b4f81ac5.png";